import AuthActionTypes from 'store/modules/auth/constants';
import { ApplicationActions } from 'store/types';
import { upsertSafeChildProperties } from 'utils/Object/properties/upsert-child-property';

import ActionTypes from './constants';
import { DevicesState } from './types';
import { computeDevice } from './utils/compute-device';

export const initialState: DevicesState = {};

function devicesReducer(
  state: DevicesState = initialState,
  action: ApplicationActions
): DevicesState {
  switch (action.type) {
    case ActionTypes.SET_DEVICES: {
      const devices = action.payload;
      for (const id in devices) {
        devices[id] = computeDevice(devices[id]);
      }
      return devices;
    }
    case ActionTypes.SET_DEVICE: {
      const device = computeDevice(action.payload);
      return {
        ...state,
        [device.id]: device
      };
    }
    case ActionTypes.UPDATE_DEVICE: {
      const device = computeDevice(action.payload);
      return upsertSafeChildProperties(state, [device.id], device);
    }
    case AuthActionTypes.LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export default devicesReducer;
